<script setup lang="ts">
import CurrencyText from '@uiKit/components/CurrencyText.vue'
import Box from '@uiKit/elements/Box.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'
import Text from '@uiKit/elements/Text.vue'
import { WITHDRAWAL_ARRIVAL_NOTE } from '../constants/fiatWalletConstants'

// The consequence block that sits above "Confirm Withdrawal": what leaves the
// wallet, what's left afterwards, and when it lands. Money honesty is the
// point — it renders before the investor commits, not after.
interface Props {
  currency: string
  /** Pre-formatted amount, e.g. `"10,000.00"`. */
  amount: string
  /** Pre-formatted balance after the withdrawal. */
  remaining: string
}

defineProps<Props>()
</script>

<template>
  <Box direction="col" gap="6" class="wsum-wrap">
    <Box direction="col" class="wsum">
      <Box align="center" justify="between" gap="3" class="wsum__row">
        <Text type="heading" weight="regular" color="muted" is="span">Withdrawal Amount</Text>
        <Text type="heading" weight="medium" align="right" is="span" class="wsum__value">
          <CurrencyText :text="`${currency} ${amount}`" />
        </Text>
      </Box>
      <Box align="center" justify="between" gap="3" class="wsum__row">
        <Text type="heading" weight="regular" color="muted" is="span">Remaining Balance</Text>
        <Text type="heading" weight="medium" align="right" is="span" class="wsum__value">
          <CurrencyText :text="`${currency} ${remaining}`" />
        </Text>
      </Box>
    </Box>

    <Box align="start" gap="3" class="wsum__note">
      <PiIcon name="info-circle" class="wsum__note-icon" />
      <Text type="body" color="muted" is="p">{{ WITHDRAWAL_ARRIVAL_NOTE }}</Text>
    </Box>
  </Box>
</template>

<style scoped>
.wsum {
  background: var(--p-surface-100);
  border-radius: 12px;
  padding: 0.375rem 1.25rem;
}

.wsum__row {
  padding: 0.8125rem 0;
}

.wsum__row + .wsum__row {
  border-top: 1px solid var(--p-content-border-color);
}

.wsum__value {
  font-variant-numeric: tabular-nums;
}

.wsum__note {
  background: var(--p-surface-100);
  border-radius: 12px;
  padding: 0.875rem 1.125rem;
}

.wsum__note-icon {
  font-size: 20px;
  color: var(--p-text-muted-color);
  flex-shrink: 0;
  margin-top: 2px;
}
</style>
